import { IconLibrary } from "../../../interfaces/icon/IconLibrary";
import Icon from "../icons/Icon";

interface ISearchBarButtonProps {
  isDisabled?: boolean,
  onClickButton: () => void;
  buttonLabel?: string;
  iconColor?: string
}



const SearchBarButton = ({isDisabled, onClickButton, buttonLabel, iconColor}: ISearchBarButtonProps) => {
    
    return (
        <button
            id="thrive-component-search-bar-button"
            className="thrive-component-search-bar-button"
            type="button"
            onClick={onClickButton}
            aria-label={buttonLabel}
            disabled={isDisabled}
        >
            <Icon 
                iconName={IconLibrary.SEARCH_GLASS} 
                color={`${iconColor ?? "var(--thriveWhite)"}`}
                sizeInPx="28"
            />
        </button>
    );
};

export default SearchBarButton;